import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d88195ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "form-container"
}
const _hoisted_3 = { class: "details-container" }
const _hoisted_4 = {
  key: 0,
  class: "editing-container"
}
const _hoisted_5 = {
  class: "form-group mobile-fixed-width",
  style: {"width":"5.4vw"}
}
const _hoisted_6 = { for: "year" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["value", "selected"]
const _hoisted_9 = {
  class: "form-group mobile-fixed-width",
  style: {"width":"3.5vw"}
}
const _hoisted_10 = { for: "month" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["value", "selected"]
const _hoisted_13 = {
  class: "form-group mobile-fixed-width",
  style: {"width":"3.5vw"}
}
const _hoisted_14 = { for: "day" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["value", "selected"]
const _hoisted_17 = {
  class: "form-group mobile-fixed-width",
  style: {"width":"5.4vw"}
}
const _hoisted_18 = { for: "nnnn" }
const _hoisted_19 = ["placeholder", "disabled"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 1,
  class: "text-center",
  style: {"color":"#875e29"}
}
const _hoisted_23 = {
  key: 0,
  style: {"font-weight":"bold"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Update pending! Please check "),
  /*#__PURE__*/_createElementVNode("a", {
    style: {"color":"blue"},
    href: "https://www.student.ladok.se"
  }, " https://www.student.ladok.se ")
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  style: {"color":"blue"},
  href: "https://www.student.ladok.se"
}, "https://www.student.ladok.se", -1))
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailsHeader = _resolveComponent("DetailsHeader")!
  const _component_DetailsRow = _resolveComponent("DetailsRow")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DetailsHeader, {
      showNext: false,
      showPrevious: false,
      title: _ctx.$t('shared.routes.personal-identity-number')
    }, null, 8, ["title"]),
    ($setup.roles.includes('Student') || (_ctx.$route.query.lucatid && !$setup.isLoading))
      ? (_openBlock(), _createElementBlock("form", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_DetailsRow, {
              caption: "person.personalId",
              details: `${$setup.person?.personalId}`
            }, null, 8, ["details"]),
            _createVNode(_component_DetailsRow, {
              caption: "person.name",
              details: `${$setup.person?.firstName}`
            }, null, 8, ["details"]),
            _createVNode(_component_DetailsRow, {
              caption: "person.lastName",
              details: `${$setup.person?.lastName}`
            }, null, 8, ["details"]),
            _createVNode(_component_DetailsRow, {
              caption: "person.email",
              details: `${$setup.person?.email}`
            }, null, 8, ["details"])
          ]),
          ($setup.person && !$setup.isSubmitted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("shared.year")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "year",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.year) = $event)),
                    class: _normalizeClass(["form-control custom-select", { 'disabled-input': $setup.isSubmitted }]),
                    disabled: !$setup.hasInterimId || $setup.isSubmitted
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.years, (y) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: y,
                        value: y,
                        selected: $setup.isSubmitted && $setup.year === y
                      }, _toDisplayString(y), 9, _hoisted_8))
                    }), 128))
                  ], 10, _hoisted_7), [
                    [_vModelSelect, $setup.year]
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("shared.month")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "month",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.month) = $event)),
                    class: _normalizeClass(["form-control custom-select", { 'disabled-input': $setup.isSubmitted }]),
                    disabled: !$setup.hasInterimId || $setup.isSubmitted
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.months, (m) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: m,
                        value: m,
                        selected: $setup.isSubmitted && $setup.month === m
                      }, _toDisplayString(m), 9, _hoisted_12))
                    }), 128))
                  ], 10, _hoisted_11), [
                    [_vModelSelect, $setup.month]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("shared.day")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "day",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.day) = $event)),
                    class: _normalizeClass(["form-control custom-select", { 'disabled-input': $setup.isSubmitted }]),
                    disabled: !$setup.hasInterimId || $setup.isSubmitted
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.days, (d) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: d,
                        value: d,
                        selected: $setup.isSubmitted && $setup.day === d
                      }, _toDisplayString(d), 9, _hoisted_16))
                    }), 128))
                  ], 10, _hoisted_15), [
                    [_vModelSelect, $setup.day]
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("nnnn")), 1),
                  _withDirectives(_createElementVNode("input", {
                    id: "nnnn",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.nnnn) = $event)),
                    class: _normalizeClass(["form-control", { 'disabled-input': $setup.isSubmitted }]),
                    style: {"border-radius":"8px"},
                    placeholder: $setup.isSubmitted ? $setup.nnnn : _ctx.$t('shared.four-digits'),
                    maxlength: "4",
                    onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.validateNnnn && $setup.validateNnnn(...args))),
                    disabled: !$setup.hasInterimId || $setup.isSubmitted
                  }, null, 42, _hoisted_19), [
                    [_vModelText, $setup.nnnn]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!$setup.isSubmitted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  disabled: !$setup.isFormValid || $setup.isSubmitted,
                  onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submitUpdate && $setup.submitUpdate(...args)), ["prevent"]))
                }, _toDisplayString(_ctx.$t("shared.send")), 9, _hoisted_21),
                _createElementVNode("button", {
                  class: "btn btn-outline-primary",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.cancelUpdate && $setup.cancelUpdate(...args)), ["prevent"]))
                }, _toDisplayString(_ctx.$t("shared.cancel")), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    ($setup.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          ($setup.isLoading)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                class: _normalizeClass([`fa-3x`, "fa-spin"]),
                icon: "circle-notch"
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    ($setup.feedbackMessage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass([$setup.feedbackMessageClass, "feedback-message"])
        }, [
          _createTextVNode(_toDisplayString($setup.feedbackMessage) + " ", 1),
          (
          $setup.feedbackMessage ===
          'You have submitted a request for an update of your Personal Identity Number.'
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
            : _createCommentVNode("", true),
          (
          $setup.feedbackMessage ===
          'Your Personal Identity Number has been updated in the Study Administration Systems.'
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}